<template>
  <v-sheet class="button-group" v-if="cameras.length > 1 || hasTorchCapability">
    <v-btn
      v-if="hasTorchCapability"
      class="button"
      v-bind="buttonProps"
      :prepend-icon="torchToggled ? 'msf:flashlight_on' : 'msf:flashlight_off'"
      @click="streamStore.toggleTorch()"
      :active="torchToggled"
      active-color="primary"
    >
      {{ $t('meeting.tools.light') }}
    </v-btn>
    <template v-if="cameras.length > 1">
      <v-btn
        ref="cameraButton"
        class="button"
        v-bind="buttonProps"
        prepend-icon="msf:autorenew"
        @click="onClickCamera"
        :active="menuOpened"
      >
        {{ $t('meeting.tools.camera') }}
      </v-btn>
      <v-menu
        v-if="cameras.length > 2"
        :close-on-content-click="false"
        :offset="[10, 0]"
        :target="cameraButton"
        v-model:model-value="menuOpened"
      >
        <v-sheet class="device-list">
          <v-list
            density="compact"
            :selected="[selectedCameraId]"
            :mandatory="true"
            :slim="true"
            @click:select="onSelectCamera"
          >
            <v-list-item
              class="device-item"
              v-for="device in cameras"
              :key="device.deviceId"
              :value="device.deviceId"
              :active="device.deviceId === selectedCameraId"
              color="primary"
              variant="text"
              :title="device.label"
            />
          </v-list>
        </v-sheet> </v-menu
    ></template>
  </v-sheet>
</template>
<script setup>
import {useSessionStore} from '@/stores'
import {useStreamStore} from '@/stores/streamStore'
import {storeToRefs} from 'pinia'
import {ref} from 'vue'
const streamStore = useStreamStore()
const {restartCam} = streamStore
const {cameras, selectedCameraId, hasTorchCapability, torchToggled} = storeToRefs(streamStore)
const menuOpened = ref(false)
const cameraButton = ref()
const session = useSessionStore()
const buttonProps = {
  stacked: true,
  density: 'compact',
  size: 'small',
  variant: 'flat',
  rounded: 4,
  'active-color': 'primary',
}

const onClickCamera = async event => {
  event.stopPropagation()
  if (cameras.value.length === 2) {
    const otherOption = cameras.value.find(d => d.deviceId !== selectedCameraId.value)
    selectedCameraId.value = otherOption.deviceId
  } else {
    menuOpened.value = !menuOpened.value
  }
}
const onSelectCamera = async ({id}) => {
  if (selectedCameraId.value === id) {
    await restartCam()
  } else {
    selectedCameraId.value = id
  }
  menuOpened.value = false
}
</script>
<style scoped lang="scss">
@import '@/scss/button-group.scss';
.button-group {
  flex-direction: column;
}
.device-list {
  padding: $spacing-xxs $spacing-xs;
}
.device-item {
  :deep(.v-list-item__overlay) {
    background: none;
  }
}
</style>
